import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _579cc0ab = () => interopDefault(import('../pages/datenschutz.vue' /* webpackChunkName: "pages/datenschutz" */))
const _6e6d89ff = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _786a2183 = () => interopDefault(import('../pages/wissen.vue' /* webpackChunkName: "pages/wissen" */))
const _de14f7be = () => interopDefault(import('../pages/l/federweisser.vue' /* webpackChunkName: "pages/l/federweisser" */))
const _5558d004 = () => interopDefault(import('../pages/l/lage.vue' /* webpackChunkName: "pages/l/lage" */))
const _929850a8 = () => interopDefault(import('../pages/l/nacht-der-guten-weine.vue' /* webpackChunkName: "pages/l/nacht-der-guten-weine" */))
const _203ab60c = () => interopDefault(import('../pages/l/neue-weine/index.vue' /* webpackChunkName: "pages/l/neue-weine/index" */))
const _1f2bcc70 = () => interopDefault(import('../pages/l/prima-probier-paket.vue' /* webpackChunkName: "pages/l/prima-probier-paket" */))
const _731e2c38 = () => interopDefault(import('../pages/l/veranstaltungen.vue' /* webpackChunkName: "pages/l/veranstaltungen" */))
const _5146f631 = () => interopDefault(import('../pages/l/wein-des-monats/index.vue' /* webpackChunkName: "pages/l/wein-des-monats/index" */))
const _3815beaa = () => interopDefault(import('../pages/l/willkommen.vue' /* webpackChunkName: "pages/l/willkommen" */))
const _1a918c66 = () => interopDefault(import('../pages/l/wissen-federweisser.vue' /* webpackChunkName: "pages/l/wissen-federweisser" */))
const _15d2b57d = () => interopDefault(import('../pages/l/wissen-restzucker-sekt.vue' /* webpackChunkName: "pages/l/wissen-restzucker-sekt" */))
const _9ccdaa96 = () => interopDefault(import('../pages/l/wissen-restzucker-wein.vue' /* webpackChunkName: "pages/l/wissen-restzucker-wein" */))
const _f267c424 = () => interopDefault(import('../pages/l/wissen-so-macht-man-das-murmeln.vue' /* webpackChunkName: "pages/l/wissen-so-macht-man-das-murmeln" */))
const _c5363012 = () => interopDefault(import('../pages/l/wissen-spargel-wein.vue' /* webpackChunkName: "pages/l/wissen-spargel-wein" */))
const _2bbf7cb5 = () => interopDefault(import('../pages/l/neue-weine/_slug/index.vue' /* webpackChunkName: "pages/l/neue-weine/_slug/index" */))
const _2859c8ac = () => interopDefault(import('../pages/l/wein-des-monats/_slug/index.vue' /* webpackChunkName: "pages/l/wein-des-monats/_slug/index" */))
const _a2d7164c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/datenschutz",
    component: _579cc0ab,
    name: "datenschutz"
  }, {
    path: "/impressum",
    component: _6e6d89ff,
    name: "impressum"
  }, {
    path: "/wissen",
    component: _786a2183,
    name: "wissen"
  }, {
    path: "/l/federweisser",
    component: _de14f7be,
    name: "l-federweisser"
  }, {
    path: "/l/lage",
    component: _5558d004,
    name: "l-lage"
  }, {
    path: "/l/nacht-der-guten-weine",
    component: _929850a8,
    name: "l-nacht-der-guten-weine"
  }, {
    path: "/l/neue-weine",
    component: _203ab60c,
    name: "l-neue-weine"
  }, {
    path: "/l/prima-probier-paket",
    component: _1f2bcc70,
    name: "l-prima-probier-paket"
  }, {
    path: "/l/veranstaltungen",
    component: _731e2c38,
    name: "l-veranstaltungen"
  }, {
    path: "/l/wein-des-monats",
    component: _5146f631,
    name: "l-wein-des-monats"
  }, {
    path: "/l/willkommen",
    component: _3815beaa,
    name: "l-willkommen"
  }, {
    path: "/l/wissen-federweisser",
    component: _1a918c66,
    name: "l-wissen-federweisser"
  }, {
    path: "/l/wissen-restzucker-sekt",
    component: _15d2b57d,
    name: "l-wissen-restzucker-sekt"
  }, {
    path: "/l/wissen-restzucker-wein",
    component: _9ccdaa96,
    name: "l-wissen-restzucker-wein"
  }, {
    path: "/l/wissen-so-macht-man-das-murmeln",
    component: _f267c424,
    name: "l-wissen-so-macht-man-das-murmeln"
  }, {
    path: "/l/wissen-spargel-wein",
    component: _c5363012,
    name: "l-wissen-spargel-wein"
  }, {
    path: "/l/neue-weine/:slug",
    component: _2bbf7cb5,
    name: "l-neue-weine-slug"
  }, {
    path: "/l/wein-des-monats/:slug",
    component: _2859c8ac,
    name: "l-wein-des-monats-slug"
  }, {
    path: "/",
    component: _a2d7164c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
